import React, { ReactNode, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import useIsMobile from '../../../hooks/global/UseIsMobile';
import { MOBILE_HEADER_ACTIONS_ID, MOBILE_HEADER_TITLE_ID } from './MobileMenu';

interface MobilePageHeaderProps {
  /** Zastępuje logo i „+” w pasku (np. nazwa projektu). */
  title?: ReactNode;
  /** Przyciski po prawej stronie paska. */
  actions?: ReactNode;
}

interface Slots {
  title: HTMLElement | null;
  actions: HTMLElement | null;
}

const NO_SLOTS: Slots = { title: null, actions: null };

/**
 * Wstawia treść strony do górnego paska wersji mobilnej (`MobileMenu`). Na desktopie nic nie renderuje —
 * strona pokazuje wtedy te same elementy u siebie. Stan zostaje w stronie: portal przenosi tylko DOM.
 */
const MobilePageHeader: React.FC<MobilePageHeaderProps> = ({ title, actions }) => {
  const isMobile = useIsMobile();
  const [slots, setSlots] = useState<Slots>(NO_SLOTS);

  // Sloty żyją w `Layout` nad stroną, więc po zamontowaniu strony już są w DOM. Layout effect, żeby
  // treść weszła do paska przed pierwszym malowaniem, a nie klatkę później.
  useLayoutEffect(() => {
    setSlots(
      isMobile
        ? {
            title: document.getElementById(MOBILE_HEADER_TITLE_ID),
            actions: document.getElementById(MOBILE_HEADER_ACTIONS_ID),
          }
        : NO_SLOTS
    );
  }, [isMobile]);

  return (
    <>
      {title && slots.title && createPortal(title, slots.title)}
      {actions && slots.actions && createPortal(actions, slots.actions)}
    </>
  );
};

export default MobilePageHeader;
